<template lang="pug">
#empresa-bloco-inserir-contrato-originacao-planilha
    el-card(:body-style='{ padding: "20px" }')
        .bloco-inserir-contrato-originacao-mensagem-informativa_texto
            span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informativoPrimario') }}
            span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informativoSecundario') }}

        .bloco-inserir-contrato-originacao-planilha__linha
            div(v-if='messages')
                ul.bloco-inserir-contrato-originacao-planilha__campos
                    li.valores(
                        v-for='mensagem in messages',
                        :key='mensagem',
                        :class='verficarCampoObrigatorio(mensagem)'
                    ) {{ $t(`mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.cabecalho.${mensagem}`) }}

            .bloco-inserir-contrato-originacao-planilha__upload
                el-upload(
                    action='#',
                    :auto-upload='false',
                    :on-change='enviarPlanilha',
                    :on-exceed='onExceed',
                    :file-list='fileList',
                    :limit='1',
                    drag,
                    ref='uploadPlanilhaContratoOriginacao'
                )
                    i.el-icon-upload
                    .el-upload__text {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informativoArrasteAqui') }} <em>{{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informativoCliqueAqui') }}</em>

                .bloco-card-inserir-dados-planilha__conteudo__bloco__buttons
                    span.btn-download(@click='downloadPlanilhaExemplo()')
                        i.mdi.mdi-download
                        span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.baixarModeloPlanilha') }}
        div(v-if='dadosLote')
            hr
            div
                el-descriptions(:column='5', direction='vertical')
                    template(slot='title')
                        span.bloco-inserir-contrato-originacao-planilha-lote__titulo {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.dadosUltimoLote') }}
                    el-descriptions-item(
                        contentClassName='bloco-inserir-contrato-originacao-planilha-lote__importada'
                    )
                        template(slot='label')
                            span.bloco-inserir-contrato-originacao-planilha-lote__label {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.planilhaImportada') }}
                        el-tooltip(
                            effect='dark',
                            :content='dadosLote.planilha',
                            placement='top'
                        )
                            |
                            span {{ dadosLote.planilha }}
                    el-descriptions-item(v-if='dadosLote.planilhaErro')
                        template(slot='label')
                            span.bloco-inserir-contrato-originacao-planilha-lote__label {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.planilhaComErro') }}
                        el-button(
                            type='primary',
                            size='mini',
                            icon='el-icon-download',
                            @click='fazerDownload(dadosLote.id)'
                        ) {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.fazerDownload') }}
                    el-descriptions-item
                        template(slot='label')
                            span.bloco-inserir-contrato-originacao-planilha-lote__label {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.dataCadastro') }}
                        | {{ dadosLote.dataCadastro }}
                    el-descriptions-item
                        template(slot='label')
                            span.bloco-inserir-contrato-originacao-planilha-lote__label {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.ultimaAtualizacao') }}
                        | {{ dadosLote.dataAtualizacao }}
                    el-descriptions-item(label='Status')
                        template(slot='label')
                            span.bloco-inserir-contrato-originacao-planilha-lote__label {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.status') }}
                        el-tag(
                            v-if='dadosLote.statusCodigo === "EM_PROCESSAMENTO"',
                            type='info'
                        )
                            |
                            i.el-icon-loading(
                                v-if='dadosLote.statusCodigo === "EM_PROCESSAMENTO"'
                            )
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.statusUpload.EM_PROCESSAMENTO') }}
                        el-tag(
                            v-if='dadosLote.statusCodigo === "PROCESSADO_COM_ERRO"',
                            type='warning'
                        ) {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.statusUpload.PROCESSADO_COM_ERRO') }}
                        el-tag(
                            v-if='dadosLote.statusCodigo === "PROCESSADO"',
                            type='success'
                        ) {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.statusUpload.PROCESSADO') }}
                        el-tag(
                            v-if='dadosLote.statusCodigo === "ERRO_PROCESSAR"',
                            type='danger'
                        ) {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.statusUpload.ERRO_PROCESSAR') }}
</template>

<script>
import ContratoOriginacaoServiceEmpresa from '@/services/ContratoOriginacaoServiceEmpresa';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import { mapGetters } from 'vuex';

export default {
    name: 'EmpresaBlocoInserirContratoOriginacaoPlanilha',

    data() {
        return {
            fileList: [],
            messages: [],
            dadosLote: null
        };
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    mounted() {
        this.buscarDadosLote();
        this.conectarCanalNotificacaoProcessamento();
    },
    created() {
        this.listagemInformacoesBaseadaNoUsuario();
    },
    beforeDestroy() {
        disconnect();
    },
    methods: {
        onExceed() {
            this.$notify.warning({
                message: this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.limiteArquivo'
                ),
                position: 'top-left'
            });
        },
        async enviarPlanilha(planilha) {
            if (
                this.dadosLote &&
                this.dadosLote.statusCodigo === 'EM_PROCESSAMENTO'
            ) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.erroDevidoProcessamento'
                    )
                );
                this.$refs.uploadPlanilhaContratoOriginacao.clearFiles();
                return false;
            }

            if (planilha.size > 15000000) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.limiteTamanho'
                    )
                );
                this.$refs.uploadPlanilhaContratoOriginacao.clearFiles();
                return false;
            }
            let extension = planilha.name.split('.').pop().toLowerCase();

            if (extension !== 'xlsx') {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.erroExtensaoArquivo'
                    )
                );
                this.$refs.uploadPlanilhaContratoOriginacao.clearFiles();
                return false;
            }

            try {
                this.$notify.success(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.arquivoSendoEnviado'
                    )
                );
                await ContratoOriginacaoServiceEmpresa.cadastrarViaPlanilha(
                    planilha,
                    this.usuarioLogado.ambienteLogado
                );
                this.$notify.success(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.arquivoEnviadoComSucesso'
                    )
                );
                this.buscarDadosLote();
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.erroEnviarArquivo'
                    )
                );
            }
            this.$refs.uploadPlanilhaContratoOriginacao.clearFiles();
        },

        async buscarDadosLote() {
            try {
                const { data } =
                    await ContratoOriginacaoServiceEmpresa.buscarDadosLoteEmpresa();
                if (data) {
                    this.dadosLote = data;
                }
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.erroBuscarDados'
                    )
                );
            }
        },

        fazerDownload(id) {
            ContratoOriginacaoServiceEmpresa.downloadPlanilhaComErro(id)
                .then(() => {
                    this.$notify.success(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.downloadRealizadoComSucesso'
                        )
                    );
                })
                .catch(() => {
                    this.$notify.error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.erroRealizarDownload'
                        )
                    );
                });
        },

        async conectarCanalNotificacaoProcessamento() {
            try {
                await connect();
            } catch {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.erroConectarWs'
                    )
                );
                return;
            }

            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/lote/contrato-originacao/cadastro`,
                    response => {
                        this.dadosLote = JSON.parse(response);
                        this.$notify.success(
                            this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.processamentoAtualizado'
                            )
                        );
                        this.$emit('atualizarTabelaContratosNaoEnviados');
                    }
                );
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.informacaoUpload.erroExportarPdf'
                    )
                );
                disconnect();
            }
        },

        verficarCampoObrigatorio(mensagem) {
            const ignorar = ['', 'departamento', 'ibge', 'sucursal'];
            return ignorar.includes(mensagem) ? '' : 'obrigatorio';
        },

       listagemInformacoesBaseadaNoUsuario() {
            const MENSAGENS_POR_AMBIENTE = {
                BR: [
                    'contratoMaster',
                    'material',
                    'anoSafra',
                    'dataContratoMaster',
                    'parceiroAgrupador',
                    'cnpj',
                    'segmento',
                    'canal',
                    'estado',
                    'cidadeDoParceiro',
                    'regional',
                    'gerenteRegional',
                    'gerenteComercial',
                    'gestorTerritorial',
                    'volContratado',
                    'volRecebido',
                    'valor',
                    'dataDoPagamento',
                    'condicaoDeFrete',
                    'local',
                    'ibge',
                    'tipoContrato'
                ],
                PY: [
                    'numeroContrato',
                    'cultura',
                    'dataContrato',
                    'safra',
                    'fornecedor',
                    'ruc',
                    'departamento',
                    'volContratado'
                ],
                AR: [
                    'numeroContrato',
                    'corredor',
                    'sucursal',
                    'vendedor',
                    'produto',
                    'anoAfip',
                    'dataContrato',
                    'dataEntrega',
                    'cuitCorredor',
                    'cuitVendedor',
                    'condicaoCliente',
                    'provincia',
                    'departamento',
                    'localidade',
                    'estrutura',
                    'volumeContratado',
                    'idPlantaEntregaBunge',
                    'condicaoFrete'
                ]
            };

            const ambiente = this.usuarioLogado.ambienteLogado;
            const mensagens = [...(MENSAGENS_POR_AMBIENTE[ambiente])];

            if (this.usuarioLogado.isLDC) {
                mensagens.push('subTrading');
            }

            this.messages = [...mensagens];
        },

        downloadPlanilhaExemplo() {
            let link = document.createElement('a');
            let linkDownloadPlanilha = this.$t(
                'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.planilhaExemploContratoUrl'
            );

            if (this.usuarioLogado.ambienteLogado === 'PY') {
                if (this.usuarioLogado.isLDC) {
                    linkDownloadPlanilha = this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.planilhaExemploContratoUrlLDC'
                    );
                } else {
                    linkDownloadPlanilha = this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.planilhaExemploContratoUrlPY'
                    );
                }
            } else if (this.usuarioLogado.ambienteLogado === 'AR') {
                linkDownloadPlanilha = this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.planilhaExemploContratoUrlAR'
                );
            }

            link.setAttribute(
                'download',
                this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaPlanilha.planilhaAtributoNome'
                )
            );
            link.href = linkDownloadPlanilha;
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
    }
};
</script>

<style lang="scss">
#empresa-bloco-inserir-contrato-originacao-planilha {
    .bloco-inserir-contrato-originacao-planilha__linha {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 5rem;

        .bloco-inserir-contrato-originacao-planilha__campos {
            width: 500px;
            column-count: 2;

            li.obrigatorio::after {
                content: ' *';
                color: #f56c6c;
            }
        }

        .bloco-card-inserir-dados-planilha__conteudo__bloco__buttons {
            display: flex;
            gap: 15px;
            width: 100%;
            justify-content: flex-end;
            align-items: center;
            .btn-download {
                cursor: pointer;
                display: flex;
                gap: 5px;
                font-weight: 600;
                i {
                    font-size: 15px;
                }
                span {
                    text-decoration: underline;
                    color: var(--primary);
                }
            }
        }
    }

    .bloco-inserir-contrato-originacao-mensagem-informativa_texto {
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        margin-bottom: 20px;
    }

    .bloco-inserir-contrato-originacao-planilha__upload {
        width: 100%;
        i {
            color: var(--primary);
            font-size: 30px;
        }
    }

    .bloco-inserir-contrato-originacao-planilha-lote__titulo {
        font-size: 16px;
        font-weight: bold;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .bloco-inserir-contrato-originacao-planilha-lote__importada {
        display: inline-block;
        width: 200px;
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: ellipsis;
        padding-top: 5px;
    }

    .bloco-inserir-contrato-originacao-planilha-lote__label {
        font-weight: bold;
        color: var(--primary);
    }

    .el-icon-loading {
        font-size: 15px;
        color: var(--primary);
        margin-right: 5px;
    }

    .el-upload-list__item-name [class^='el-icon'] {
        height: 100% !important;
        margin-right: 7px !important;
        color: #909399 !important;
        line-height: inherit !important;
        font-size: 14px !important;
    }

    .el-upload-dragger:hover {
        border-color: var(--primary);
    }

    .el-upload-dragger {
        background-color: #f3f3f3;
    }
}
</style>
